import React from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from 'components/forms/basefields/Dropdown';
import { EmailConnectedFeature, TemplateTag, templateTagsByFeature } from './templateTags';
import { getPreferredTagKey } from './templateTagResolvers';

interface EmailTemplateTagDropdownOption {
    value: string;
    name: string;
    tag: string;
    label: string;
}

interface EmailTemplateTagSelectorProps {
    connectedFeature?: string | null;
    locale?: string | null;
    onSelect: (tag: string) => void;
}

const EmailTemplateTagSelector: React.FC<EmailTemplateTagSelectorProps> = ({
    connectedFeature,
    locale,
    onSelect
}) => {
    const { t } = useTranslation();
    const selectedOption = null;

    // Get the tags linked to the connected feature
    const tags: TemplateTag[] = connectedFeature
        ? templateTagsByFeature[connectedFeature as EmailConnectedFeature] ?? []
        : [];

    // Generate the tag options
    const tagOptions: EmailTemplateTagDropdownOption[] = tags.map(tag => {
        const key = getPreferredTagKey(tag, locale);
        return {
            value: key,
            name: `{${key}}`,
            tag: `{${key}}`,
            label: tag.label,
        };
    });

    return (
        <div className='edit-mode'>
            <label>
                {t('email.email_template.insert_tag_label')}
            </label>
            <Dropdown<EmailTemplateTagDropdownOption>
                options={tagOptions}
                id='email_template_tag'
                name='email_template_tag'
                disabled_selected={t('email.email_template.insert_tag_disabled_selected')}
                selectedOption={selectedOption}
                onChange={(selectedValue) => {
                    const selectedTag = tagOptions.find(tagOption => tagOption.value === selectedValue);
                    if (selectedTag) {
                        onSelect(selectedTag.tag);
                    }
                }}
                selectionFormat={(option) => `${option.name}`}
                optionFormat={(option) => `${option.name}`}
                showSearch={true}
                allowNoneOption={false}
                sortOptions={false}
            />
            <p className='helper-text'>
                {t('email.email_template.insert_tag_helperText')}
            </p>
        </div>
    );
};

export default EmailTemplateTagSelector;